import { getCookie } from "../../utils/cookie_utils";

const CookieHandler = {

	getLanguage(){
		return  getCookie('LecomUserLanguage');
	}

}

export default CookieHandler;
